import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PusherService from '../PusherService';
import config from '../config/env';
import { setForceLogout } from '../redux/slices/authSlice';

/**
 * Custom hook to manage Pusher channel subscriptions.
 * Subscribes to the appropriate channel based on the environment and listens for deployment events.
 */
const usePusherSubscriptions = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    let channelName = '';
    if (config.isLocal) {
      channelName = 'local';
    } else if (config.isDevelopment) {
      channelName = 'dev';
    } else if (config.isProduction) {
      channelName = 'prod';
    }

    if (channelName) {
      try {
        const channel = PusherService.subscribe(channelName);
        channel.bind('deployment', () => {
          localStorage.setItem('FORCE_RELOAD', true);
        });

        channel.bind('force_logout', (data) => {
          console.log('data', data);
          const { userId, email } = JSON.parse(data);
          const userInfo = JSON.parse(localStorage.getItem('userInfo'));
          if (userId === userInfo?.id && email === userInfo?.email) {
            dispatch(setForceLogout(true));
          }
        });

        // Cleanup subscription on unmount
        return () => {
          PusherService.unsubscribe(channelName);
        };
      } catch (error) {
        console.error('Pusher subscription error:', error);
      }
    }
  }, [dispatch]);
};

export default usePusherSubscriptions;
